import React from "react";
import { Link } from "react-router-dom";

import { Col, Container, Row } from "components/site/SitePrimitives";
import {
  contactDetails,
  footerContent,
  footerLinks,
} from "content/siteContent";

function SiteFooter() {
  return (
    <footer className="site-footer">
      <Container>
        <Row className="site-grid-gap">
          <Col lg="5">
            <div className="site-footer-brand">
              <p className="site-eyebrow mb-3">Ignitum Solutions</p>
              <h3 className="mb-3">Advanced software. Trustworthy systems.</h3>
              <p>{footerContent.blurb}</p>
            </div>
          </Col>
          <Col md="6" lg="3">
            <h5 className="site-footer-heading">Navigation</h5>
            <ul className="site-footer-links">
              {footerLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to}>{link.footerLabel || link.label}</Link>
                </li>
              ))}
            </ul>
          </Col>
          <Col md="6" lg="4">
            <h5 className="site-footer-heading">Contact</h5>
            <ul className="site-footer-links">
              <li>
                <a href={`mailto:${contactDetails.email}`}>{contactDetails.email}</a>
              </li>
              <li>
                <a
                  href={contactDetails.linkedin}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  LinkedIn
                </a>
              </li>
            </ul>
          </Col>
        </Row>

        <div className="site-footer-bottom">
          <span>© {new Date().getFullYear()} Ignitum Solutions, LLC</span>
          {footerContent.note ? <span>{footerContent.note}</span> : null}
        </div>
      </Container>
    </footer>
  );
}

export default SiteFooter;
